"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("./Style.css");
var _ContactCard = _interopRequireDefault(require("./components/ContactCard"));
var _idbReactIconlib = _interopRequireDefault(require("@identitybuilding/idb-react-iconlib"));
var _MapMarker = _interopRequireDefault(require("@identitybuilding/idb-react-map/dist/MapMarker"));
var _OpeningHours = _interopRequireDefault(require("./components/OpeningHours"));
var _react = _interopRequireWildcard(require("react"));
var _Services = _interopRequireDefault(require("./components/Services"));
var _SocialMedia = _interopRequireDefault(require("./components/SocialMedia"));
var _idbReactTranslations = _interopRequireDefault(require("@identitybuilding/idb-react-translations"));
var _Contacts = _interopRequireDefault(require("./components/Contacts"));
var _leaflet = require("leaflet");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } // import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
var Contact = function Contact(_ref) {
  var _setSendMail = _ref.setSendMail,
    card_theme = _ref.card_theme,
    _ref$entity = _ref.entity,
    entity = _ref$entity === void 0 ? {} : _ref$entity,
    lang = _ref.lang,
    social_media = _ref.social_media,
    theme = _ref.theme,
    id = _ref.id,
    entity_id = _ref.entity_id,
    parts = _ref.parts,
    tab = _ref.tab,
    setTab = _ref.setTab,
    contacts = _ref.contacts,
    services = _ref.services,
    setContacts = _ref.setContacts,
    setServices = _ref.setServices,
    contactView = _ref.contactView,
    setContactView = _ref.setContactView,
    social_media_data = _ref.social_media_data,
    title = _ref.title,
    CaptchaKey = _ref.CaptchaKey;
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    tabs = _useState2[0],
    setTabs = _useState2[1],
    _useState3 = (0, _react.useState)('opening_hours'),
    _useState4 = _slicedToArray(_useState3, 2),
    view = _useState4[0],
    setView = _useState4[1],
    translate = function translate(e) {
      return (0, _idbReactTranslations["default"])(e, lang);
    };
  (0, _react.useEffect)(function () {
    // When contacts needs to be shown again, add this code:
    // setTabs([...tabs, "opening_hours", "contacts", "facilities"])
    var tab_items = _toConsumableArray(tabs);
    if (parts.openinghours !== false) {
      tab_items.push("opening_hours");
    }
    if (parts.facilities) {
      tab_items.push("facilities");
    }
    if (parts.contacts) {
      tab_items.push("contact_persons");
    }
    setTabs(tab_items);
    if (!parts.openinghours && !parts.facilities) {
      setView(contactView ? contactView : 'contact_persons');
    } else if (!parts.openinghours) {
      setView(contactView ? contactView : 'facilities');
    } else {
      setView(contactView ? contactView : 'opening_hours');
    }
  }, []);
  var bounds = (0, _leaflet.latLngBounds)();
  bounds.extend([entity.address.lat, entity.address["long"]]);
  if (!bounds.isValid()) {
    throw new Error('Bounds are not valid. MAN');
  }
  return /*#__PURE__*/_react["default"].createElement("section", {
    id: "contact",
    className: theme ? theme : "light"
  }, title && /*#__PURE__*/_react["default"].createElement("h2", null, title === 'contact_and_opening_hours' ? translate("contact_and_opening_hours") : title, " "), /*#__PURE__*/_react["default"].createElement("div", {
    className: "contactWrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "contactContent"
  }, social_media && /*#__PURE__*/_react["default"].createElement(_SocialMedia["default"], {
    id: entity_id,
    lang: lang,
    data: social_media_data,
    openMail: false,
    CaptchaKey: CaptchaKey,
    setSendMail: function setSendMail(e) {
      return _setSendMail(e);
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "contactConWrapper",
    style: {
      width: social_media ? "calc(100% - 40px)" : "100%"
    }
  }, entity && /*#__PURE__*/_react["default"].createElement(_ContactCard["default"], {
    color: card_theme,
    entity: entity,
    lang: lang
  }), tabs.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    id: "OHtabs"
  }, tabs.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "OHsubTab ".concat(tab === index ? "active" : ""),
      key: item,
      onClick: function onClick() {
        setTab(index), setView(item), setContactView(item);
      }
    }, /*#__PURE__*/_react["default"].createElement("span", null, translate(item)), /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
      name: "ArrowUp"
    }));
  })), view === 'opening_hours' && parts.openinghours && typeof parts.openinghours !== 'string' ? /*#__PURE__*/_react["default"].createElement(_OpeningHours["default"], {
    lang: lang,
    openinghours: entity.openinghours,
    oh_received: parts.openinghours,
    id: entity_id
  }) : view === 'opening_hours' && parts.openinghours !== false && /*#__PURE__*/_react["default"].createElement("div", {
    className: "timetable_message_wrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "timetable_message_image"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: require('./library/plenny.png'),
    alt: "plenny"
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: "timetable_message"
  }, (0, _idbReactTranslations["default"])('opening_hours_check', lang))), view === 'facilities' && parts.facilities && /*#__PURE__*/_react["default"].createElement(_Services["default"], {
    lang: lang,
    id: entity_id,
    facilities: services,
    setFacilities: function setFacilities(e) {
      return setServices(e);
    }
  }), view === 'contact_persons' && parts.contacts && /*#__PURE__*/_react["default"].createElement(_Contacts["default"], {
    CaptchaKey: CaptchaKey,
    id: entity_id,
    lang: lang,
    persons: contacts,
    setPersons: function setPersons(e) {
      return setContacts(e);
    },
    setSendMail: function setSendMail(e) {
      return _setSendMail(e);
    }
  }))), entity && /*#__PURE__*/_react["default"].createElement("div", {
    id: "mapWrpr"
  }, /*#__PURE__*/_react["default"].createElement(_MapMarker["default"], {
    bounds: bounds,
    addresses: [{
      data: entity
    }],
    page: "bp"
  }))));
};
var _default = exports["default"] = Contact;